export var ElementState;
(function (ElementState) {
    ElementState["static"] = "static";
    ElementState["hover"] = "hover";
    ElementState["focus"] = "focus";
    ElementState["active"] = "active";
    ElementState["disabled"] = "disabled";
})(ElementState || (ElementState = {}));
